import { createContext, useContext } from 'react';

import ClientLogger from '~logger/client';
import { LoggerMessages, LoggerServices } from '~logger/constants';

import type { TChatReviewModalContext } from './types';

export const ChatReviewModalContext = createContext<TChatReviewModalContext>({
	openReviewModal: () => () => undefined,
});

export const useChatReviewModalContext = () => {
	const context = useContext(ChatReviewModalContext);
	if (!context) {
		ClientLogger.error(
			LoggerServices.ChatService,
			LoggerMessages.ChatReviewModalContextError,
			{}
		);
		throw Error('ChatReviewModalContext context no context Provider');
	}
	return context;
};
